module.exports = __webpack_public_path__ + "static/media/силовые - вертикальная тяга.5fe8aa35.jpg";